import { createRoot, Root } from 'react-dom/client'

export default class BaseElement extends HTMLElement {
  protected get observedAttributes () {
    return []
  }

  protected rootElement: Root

  constructor () {
    super()

    this.rootElement = createRoot(this!)
    this.renderElement()
  }

  attributeChangedCallback () {
    this.renderElement()
  }

  protected renderElement () {}
}
